<template>
  <div class="row">
    <div class="col">
      <h2 class="titre">Consultation Mandat PSU</h2>
    </div>
  </div>
  <div v-if="isDataLoading == true" class="row">
    <div class="col">
      <vue-loaders name="ball-beat"></vue-loaders>
    </div>
  </div>
  <div v-else class="row">
    <div class="col">
      <div class="row border">
        <div class="col">
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Mandat :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.numeroMandat"> ... </p>
                  <p v-else> {{ mandat.numeroMandat }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-3 lbl">
                  <label>Du :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.dateDebut"> ... </p>
                  <p v-else> {{ $commun.formatDateHeure(mandat.dateDebut) }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col-3 lbl">
                  <label>Au :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.dateFin"> ... </p>
                  <p v-else> {{ $commun.formatDateHeure(mandat.dateFin) }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Action :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.typeAccesAfficher"> ... </p>
                  <p v-else> {{ mandat.typeAccesAfficher }} </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Description :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.description"> ... </p>
                  <p v-else> {{ mandat.description }} </p>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Statut :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.statutAfficher"> ... </p>
                  <p v-else> {{ mandat.statutAfficher }} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col mr2 border">
          <label class="sous-section">Dossier</label>
          <div class="row">
            <div class="col lbl">
              <label>Entité :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierEntiteAfficher"> ... </p>
              <p v-else> {{ mandat.dossierEntiteAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Site :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierSiteAfficher"> ... </p>
              <p v-else> {{ mandat.dossierSiteAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Genre :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierGenreAfficher"> ... </p>
              <p v-else> {{ mandat.dossierGenreAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Nature :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierNatureAfficher"> ... </p>
              <p v-else> {{ mandat.dossierNatureAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Type :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierTypeAfficher"> ... </p>
              <p v-else> {{ mandat.dossierTypeAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Catégorie :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierCategorieAfficher"> ... </p>
              <p v-else> {{ mandat.dossierCategorieAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Fondé :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierFondeAfficher"> ... </p>
              <p v-else> {{ mandat.dossierFondeAfficher }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Intervenant :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierIntervenant"> ... </p>
              <p v-else> {{ mandat.dossierIntervenant }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>Numéro de dossier :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierNumeroDossier"> ... </p>
              <p v-else> {{ mandat.dossierNumeroDossier }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>No Cardex :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.dossierNumeroCardex"> ... </p>
              <p v-else> {{ mandat.dossierNumeroCardex }} </p>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="row ml2 border">
            <label class="sous-section">Sujets</label>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Numéro de sujet :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.sujetNumeroFiche"> ... </p>
                  <p v-else> {{ mandat.sujetNumeroFiche }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Nom :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.sujetNom"> ... </p>
                  <p v-else> {{ mandat.sujetNom }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Prénom :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.sujetPrenom"> ... </p>
                  <p v-else> {{ mandat.sujetPrenom }} </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row ml2 border">
            <label class="sous-section">Sociétés</label>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>No de fiche :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.societeNumeroFiche"> ... </p>
                  <p v-else> {{ mandat.societeNumeroFiche }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Nom :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.societeNom"> ... </p>
                  <p v-else> {{ mandat.societeNom }} </p>
                </div>
              </div>
            </div>
          </div>
          <div class="row ml2 border">
            <label class="sous-section">Véhicules</label>
            <div class="col">
              <div class="row">
                <div class="col lbl">
                  <label>Immatriculation :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.vehiculeImmatriculation"> ... </p>
                  <p v-else> {{ mandat.vehiculeImmatriculation }} </p>
                </div>
              </div>
              <div class="row">
                <div class="col lbl">
                  <label>Province :</label>
                </div>
                <div class="col txt">
                  <p v-if="!mandat.vehiculeProvinceAfficher"> ... </p>
                  <p v-else> {{ mandat.vehiculeProvinceAfficher }} </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row border">
        <label class="sous-section">Narration</label>
        <div class="col lbl">
          <label>Mots-clés :</label>
        </div>
        <div class="col txt">
          <p v-if="!mandat.narrationMotCle1"> ... </p>
          <p v-else> {{ mandat.narrationMotCle1 }} </p>
        </div>
        <div class="col txt">
          <p v-if="!mandat.narrationMotCle2"> ... </p>
          <p v-else> {{ mandat.narrationMotCle2 }} </p>
        </div>
        <div class="col txt">
          <p v-if="!mandat.narrationMotCle3"> ... </p>
          <p v-else> {{ mandat.narrationMotCle3 }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col mr2 border">
          <div class="row">
            <div class="col lbl">
              <label>Adresses À :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.destinataireA"> ... </p>
              <p v-else> {{ mandat.destinataireA }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>CC :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.destinataireCC"> ... </p>
              <p v-else> {{ mandat.destinataireCC }} </p>
            </div>
          </div>
          <div class="row">
            <div class="col lbl">
              <label>CCI :</label>
            </div>
            <div class="col txt">
              <p v-if="!mandat.destinataireCCI"> ... </p>
              <p v-else> {{ mandat.destinataireCCI }} </p>
            </div>
          </div>
        </div>
        <div class="col ml2 border">
          <div class="row">
            <div class="col">
              <label class="sous-section">Message à envoyer :</label>
            </div>
          </div>
          <div class="row">
            <div class="col txt">
              <p v-if="!mandat.message"> ... </p>
              <p v-else> {{ mandat.message }} </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col lbl">
          <label>Créé par :</label>
        </div>
        <div class="col-4 txt">
          <p v-if="!mandat.creerParDescription"> ... </p>
          <p v-else> {{ mandat.creerParDescription }} </p>
        </div>
        <div class="col lbl">
          <label>Créé Le :</label>
        </div>
        <div class="col-4 txt">
          <p v-if="!mandat.creerLe"> ... </p>
          <p v-else> {{ $commun.formatDateHeure(mandat.creerLe) }} </p>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Permettre modification" v-on:click="modifier"/>
        </div>
        <div v-if="mandat.statut!=359" class="col">
          <Button label="Approbation" v-on:click="approuver"/>
        </div>
        <div class="col">
          <Button label="Fermer" v-on:click="fermer"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import {mapGetters} from 'vuex';

export default {
  name: 'ConsulterMandatPSU',
  mounted() {
    this.isDataLoading = true;

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Consulter un Mandat PSU");
    this.getMandatPSU();
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      actionAccesDecision: "dossier/actionAccesDecision"
    })
  },
  data() {
    return {
      isDataLoading: false,
      mandat: {},
    };
  },
  methods: {
    getMandatPSU() {
      this.$store.dispatch('mandatPSU/consulterMandatPSUAction', {
        cle: this.$route.params.cle,
        site: this.$route.params.site
      }).then((res) => {
        this.assignerMandatPSU(res);
        this.isDataLoading = false;
      })
    },
    modifier() {
      this.$router.push({
        name: "modifierMandatPSU",
        params: {
          cle: this.$route.params.cle,
          site: this.$route.params.site,
        },
      });
    },
    approuver() {
      this.$store.dispatch('cardex/obtenirProfilInfoAction', this.jeton)
          .then((res) => {
            this.mandat.approuvePar = res.data.codeProfilUtilisateur;
            this.mandat.statut = 359;
            this.$store.commit('mandatPSU/UPDATE_MANDAT', this.mandat);
            this.$store.dispatch('mandatPSU/sauvegarderMandatPSUAction', {
              cle: this.$route.params.cle,
              site: this.$route.params.site,
            }).then(() =>{
              this.isSauvegardeEnCours = false;
              this.getMandatPSU();
              this.$toast.add({
                severity: 'success', summary: 'Ajouter',
                detail: 'Le mandat PSU a été approuvé.', life: 6000
              });
            });
          });
    },
    assignerMandatPSU(res) {
      this.mandat = res.data.entite;
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
  },
}
</script>
